import React from "react";
import {TextInput} from "admin-on-rest";
import EmbeddedArrayInput from "../../../../../components/CRM/EmbeddedArrayInput";
import {required} from "../../validations";
import {formStyle} from "../../style";

class Europatipsetform extends React.Component {
  render() {
    return (
      <EmbeddedArrayInput
        label="Bet pairs"
        source="bet_pairs"
        numberOfFields="13"
        allowAdd={true}
        allowRemove={false}
        insertDividers={false}
        innerContainerStyle={formStyle.arrayInput.innerContainerStyle}
        labelContainerStyle={formStyle.arrayInput.labelContainerStyle}
      >
        <TextInput
          label=" "
          source="outcome"
          validate={required}
          elStyle={formStyle.textInput.outcomeStyle}
        />

        <TextInput
          label=""
          source="team_1"
          validate={required}
          elStyle={formStyle.textInput.teamStyle}
        />
        <TextInput
          label=""
          source="team_2"
          validate={required}
          elStyle={formStyle.textInput.teamStyle}
        />

        <div style={formStyle.clearDiv} />
      </EmbeddedArrayInput>
    );
  }
}

export default Europatipsetform;



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/TicketLayouts/Europatipset/EuropatipsetCreateForm.js